import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "17",
  fill: "none",
  viewBox: "0 0 14 17"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M.094 9.922q0-1.43.531-2.68A7 7 0 0 1 2.109 5.04a6.9 6.9 0 0 1 2.196-1.476 6.77 6.77 0 0 1 3.39-.5q.345.03.649.093L6.266 1.102A.7.7 0 0 1 6.133.89a.7.7 0 0 1-.04-.235.63.63 0 0 1 .173-.453.6.6 0 0 1 .445-.187q.28 0 .453.187l3.219 3.266q.195.202.195.469a.7.7 0 0 1-.047.25.7.7 0 0 1-.148.218L7.164 7.641q-.164.18-.453.18a.6.6 0 0 1-.438-.18.6.6 0 0 1-.18-.446q0-.125.048-.234a.7.7 0 0 1 .132-.211L8.61 4.438a6 6 0 0 0-.757-.118A9 9 0 0 0 7 4.281q-1.179 0-2.203.438a5.66 5.66 0 0 0-3.008 3.008 5.5 5.5 0 0 0-.437 2.195q0 1.18.437 2.21A5.8 5.8 0 0 0 3 13.939a5.6 5.6 0 0 0 1.797 1.203A5.55 5.55 0 0 0 7 15.578q1.172 0 2.195-.437a5.6 5.6 0 0 0 1.797-1.203q.774-.782 1.211-1.805a5.6 5.6 0 0 0 .438-2.211q0-.281.164-.461a.56.56 0 0 1 .445-.188.624.624 0 0 1 .648.648q0 1.446-.53 2.704a6.9 6.9 0 0 1-3.688 3.68 6.8 6.8 0 0 1-2.68.53 6.9 6.9 0 0 1-2.695-.53 6.9 6.9 0 0 1-2.196-1.477 7.1 7.1 0 0 1-1.484-2.203 6.9 6.9 0 0 1-.531-2.703"
    }, null, -1)
  ])))
}
export default { render: render }